import styled from 'styled-components/native'

export const Wrap = styled.View`
  align-items: center;
  justify-content: center;
  height: 80px;
`
